import React, { useEffect } from 'react'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import tts from '../../lib/TTS'
import type { FocusableLinkProps } from './types'

function FocusableLink<T extends object>({
  children,
  className = '',
  disableTTS,
  extraProps,
  focusKey,
  label = '',
  onArrowPress,
  onEnterPress,
  onFocus,
  onBlur,
  to,
}: FocusableLinkProps<T>) {
  const navigate = useNavigate()
  const { ref, focused, isHovered } = useHybridFocusable({
    focusKey,
    onArrowPress,
    extraProps,
    onEnterPress: (...args) => {
      if (onEnterPress) {
        onEnterPress(...args)
      }

      if (to) {
        navigate(to)
      }
    },
    onFocus,
    onBlur,
  })

  useEffect(() => {
    if (focused && label && !disableTTS) {
      tts.stopRead()
      tts.addTextToRead(`Focused on ${label}.`)
    }
  }, [focused, label])

  return (
    <div
      className={classNames('focusable-link', {
        [className]: !!className,
        'focusable-link--focused': focused,
        'focusable-link--hovered': isHovered,
      })}
      ref={ref}
    >
      {children}
    </div>
  )
}

export default FocusableLink
